import debounce from 'lodash.debounce'

import {Component} from 'lowkey-component'
import {MediaQuery} from '@services/MediaQuery'
import {WindowService} from '@services/WindowService'

export class ChartSections extends Component {

  mq = MediaQuery.create()
  window = WindowService.create()
  items: HTMLDivElement[] = []
  contents: HTMLDivElement[] = []

  constructor(element: HTMLDivElement) {
    super(element)
    this.onResize = debounce(this.onResize.bind(this), 100)
  }

  onResize() {
    const headerHeights =  this.items.map(item => {
      const header = item.querySelector('.m-chart-header') as HTMLDivElement
      const {height} = header.getBoundingClientRect()
      return height
    })
    const maxHeight = Math.max(...headerHeights)

    this.items.map(item => {
      const header = item.querySelector('.m-chart-header') as HTMLDivElement
      header.style.height = `${maxHeight}px`
    })

    const contentHeights = this.items.map(item => {
      const content = item.querySelector('.l-chart-section_content') as HTMLDivElement
      const {height} = content.getBoundingClientRect()
      return height
    })

    const minHeight = Math.min(...contentHeights)

    this.items.map(item => {
      const content = item.querySelector('.l-chart-section_content') as HTMLDivElement
      content.style.height = `${minHeight}px`
    })
  }

  didUnmount() {
    this.window.onResize.disconnect(this.onResize)
  }

  didMount() {

    if (this.mq.isPhone()) {
      return
    }

    this.window.onResize.connect(this.onResize)

    this.items = [...this.element.querySelectorAll('.js-chart-section')] as HTMLDivElement[]

    this.onResize()
  }

}
